// Copyright (c) Move Closer 2022.

import { PaymentMethodCode } from '../../../../contexts'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const paymentIcon: Record<string, string> = {
  [PaymentMethodCode.ApplePay]: require('./assets/images/apple-pay.svg'),
  [PaymentMethodCode.Blik]: require('./assets/images/blik.svg'),
  [PaymentMethodCode.GooglePay]: require('./assets/images/gpay.svg'),
  [PaymentMethodCode.OnDelivery]: require('./assets/images/przy-odbiorze.svg'),
  [PaymentMethodCode.PayNow]: require('./assets/images/paynow.svg'),
  [PaymentMethodCode.PayPal]: require('./assets/images/paypal.svg'),
  [PaymentMethodCode.PayU]: require('./assets/images/payu.svg'),
  [PaymentMethodCode.PayUCard]: require('./assets/images/payu.svg'),
  [PaymentMethodCode.Transfer]: require('./assets/images/przelew.png'),
  // TODO: For `Przelewy24`
  [PaymentMethodCode.Przelewy24]: require('./assets/images/przelewy24.svg'),
  [PaymentMethodCode.Przelewy24Blik]: require('./assets/images/blik.svg'),
  [PaymentMethodCode.Przelewy24InternalBlik]: require('./assets/images/blik.svg'),
  [PaymentMethodCode.Przelewy24InternalBanktransfer]: require('./assets/images/przelew.png')

}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const supportedPaymentMethods: string[] = [
  // PaymentMethodCode.Blik,
  PaymentMethodCode.OnDelivery,
  PaymentMethodCode.PayNow,
  // PaymentMethodCode.PayU,
  PaymentMethodCode.Transfer
]
